import * as i0 from "@angular/core";
export class RedirectPopupStore {
}
RedirectPopupStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RedirectPopupStore_Factory() { return new RedirectPopupStore(); }, token: RedirectPopupStore, providedIn: "root" });
export var RedirectPopupStoreKeys;
(function (RedirectPopupStoreKeys) {
})(RedirectPopupStoreKeys || (RedirectPopupStoreKeys = {}));
